export interface IConversationDetails {
  siteId: number;
  siteName: string;
  startDate: string;
  accountId: number;
  accountName: string;
  conversationId: number;
  callDetailRecordId: number;
  communicationType: string;
  communicationTypeName: string;
  agentFirstName?: string;
  agentLastName?: string;
  callDuration: number;
  callDirection: string;
}

export class ConversationDetailsModel implements IConversationDetails {
  siteId: number = 0;
  siteName: string = '';
  startDate: string = '';
  accountId: number = 0;
  accountName: string = '';
  conversationId: number = 0;
  callDetailRecordId: number = 0;
  communicationType: string = '';
  communicationTypeName: string = '';
  agentFirstName?: string = '';
  agentLastName?: string = '';
  callDuration: number = 0;
  callDirection: string = '';

  constructor(data: Partial<IConversationDetails>) {
    if (data) {
      this.siteId = data.siteId ?? this.siteId;
      this.siteName = data.siteName ?? this.siteName;
      this.startDate = data.startDate ?? this.startDate;
      this.accountId = data.accountId ?? this.accountId;
      this.accountName = data.accountName ?? this.accountName;
      this.conversationId = data.conversationId ?? this.conversationId;
      this.callDetailRecordId = data.callDetailRecordId ?? this.callDetailRecordId;
      this.communicationType = data.communicationType ?? this.communicationType;
      this.communicationTypeName = data.communicationTypeName ?? this.communicationTypeName;
      this.agentFirstName = data.agentFirstName ?? this.agentFirstName;
      this.agentLastName = data.agentLastName ?? this.agentLastName;
      this.callDuration = data.callDuration ?? this.callDuration;
      this.callDirection = data.callDirection ?? this.callDirection;
    }
  }
}
